<template>
  <div>
    <div>
      <div class="wrp">
        <div class="top-tit">Accounting Categories</div>
        <h1 class="clear">
          <span @click="linkTo('/revenue')">Revenue History</span>
          <span v-if="isRevenueTargetForecastActivated" @click="linkTo('/revenue-forcasting')">Revenue
            Forecasting</span>
          <span @click="linkTo('/income')" v-if="doshiiFlag">Doshii Area</span>
          <span  v-if="(oseriesFlag || tevalisFlag || redcatFlag || swiftPosFlag || oolioFlag) && isPro" @click="linkTo('/product-categories')">Product Categories</span>
          <span v-if="(oseriesFlag || squareFlag) && isPro" @click="linkTo('current')">Terminals</span>
          <span v-if="(oseriesFlag || tevalisFlag || redcatFlag || swiftPosFlag || oolioFlag) && isPro" @click="linkTo('/revenue-group')">Revenue Group</span>
          <span @click="linkTo('current')" class="active">Accounting Categories</span>
        </h1>

        <div>
          <div class="revenue-more custom-table table-wrp accounting-categories">
            <div class="account-table">
              <el-table :data="accounts" border style="width: 100%">
                <el-table-column prop="name" align="left">
                  <template slot="header" slot-scope="scope">
                    <div class="table-header">
                      <h2>Accounts</h2>
                    </div>
                  </template>

                  <el-table-column prop="code" label="Code" width="180">
                  </el-table-column>
                  <el-table-column prop="name" label="Name" width="180">
                  </el-table-column>
                  <el-table-column prop="status" label="Status" width="180">
                  </el-table-column>
                  <el-table-column prop="type" label="Type" width="180">
                  </el-table-column>
                  <el-table-column prop="taxType" label="Tax Type" width="180">
                  </el-table-column>
                  <el-table-column prop="description" label="Description" width="180">
                  </el-table-column>
                  <el-table-column prop="class" label="Class" width="180">
                  </el-table-column>

                </el-table-column>
                <template slot="empty">
                  <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                  <div v-else>No Data</div>
                </template>

              </el-table>

              <div class="d-flex justify-content-center">
                <el-pagination class="my_pageSel" layout="prev, pager, next"
                  @current-change="handleCurrentAccountChange" :page-size="accountPageSize" :total="accountTotal">
                </el-pagination>
              </div>
            </div>



            <div class="account-table">
              <el-table :data="manualEntries" border style="width: 100%">
                <el-table-column prop="name" align="left">
                  <template slot="header" slot-scope="scope">
                    <div class="table-header">
                      <h2>Manual Entries</h2>
                      <!-- <div>
                                      <button href="#" class="table-header__button" @click="modalOpen = true">Edit</button>
                                  </div> -->
                    </div>
                  </template>

                  <el-table-column prop="date" label="Date" width="180">
                  </el-table-column>
                  <el-table-column prop="status" label="Status" width="180">
                  </el-table-column>
                  <el-table-column prop="lineAmountTypes" label="Line Amount Type" width="280">
                  </el-table-column>
                  <el-table-column prop="narration" label="Narration" width="280">
                  </el-table-column>

                  <el-table-column prop="journalLines" label="Journal Lines">

                    <template slot-scope="scope">
                      <ul class="journal-line" v-for="(line, i) in scope.row.journalLines" :key="i">
                        <li>Account Code: {{ line.accountCode }}</li>
                        <li>Line Amount: {{ $box.formatMoney4(line.lineAmount) }}</li>
                        <li>Tax Amount: {{ $box.formatMoney4(line.taxAmount) }}</li>
                        <li>Description: {{ line.description }}</li>
                      </ul>
                    </template>
                  </el-table-column>

                </el-table-column>

                <template slot="empty">
                  <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                  <div v-else>No Data</div>
                </template>

              </el-table>

              <div class="d-flex justify-content-center">
                <el-pagination class="my_pageSel" layout="prev, pager, next" @current-change="handleCurrentChange"
                  :page-size="pageSize" :total="total">
                </el-pagination>
              </div>

            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/dashboard";
import Api from "../../api/api";
import utils from '@/utils/utils.js'
export default {
  inject: ['reload'],
  data() {
    return {
      doshiiFlag: false,
      isRevenueTargetForecastActivated: false,
      isPro: false,
      manualEntries: [],
      accounts: [],
      venueId: null,
      modalOpen: false,
      loading: false,
      oseriesFlag: false,
      redcatFlag: false,
      tevalisFlag: false,
      swiftPosFlag: false,
      oolioFlag: false,
      squareFlag: false,
      pageNum: 0,
      pageSize: 10,
      total: 1,
      accountPageSize: 10,
      accountPageNum: 0,
      accountTotal: 1,
    }
  },
  methods: {
    linkTo(path) {
      if (path === 'current') {
        this.reload()
      } else {
        this.$router.push(path)
      }
    },

    modalClose() {
      this.modalOpen = false;
    },
    async fetchManualEntries() {
      try {
        const res = await Api.xeroJournals({ date: this.getCurrentDateFormatted(), pageNum: this.pageNum })
        if (res.data.code == 0) {
          this.manualEntries = res.data.data.list;
          this.total = res.data.data.total;
        }
      } catch (error) {
        console.log('error: ', error);
      }
    },
    async fetchData() {
      this.venueId = window.sessionStorage.getItem("subVenueId");

      try {
        const res = await Api.xeroAccounts({ pageNum: this.accountPageNum })

        if (res.data.code == 0) {
          this.accounts = res.data.data.list;
          this.accountTotal = res.data.data.total;
        }
      } catch (error) {
        console.log('error: ', error);
      }

    },

    getCurrentDateFormatted() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    handleCurrentChange(page) {
      this.pageNum = page
      this.fetchManualEntries()
    },
    handleCurrentAccountChange(page) {
      this.accountPageNum = page
      this.fetchData();
    },

  },
  async mounted() {
    this.loading = true;

    await this.fetchData();
    await this.fetchManualEntries();

    this.loading = false;


    api.progress({
      callback: (res) => {
        if (res.data.code === 0 && res.data.data.doshiiFlag) {
          this.doshiiFlag = true
        }

        if (res.data.code === 0 && res.data.data.oseriesFlag) {
          this.oseriesFlag = true;
        }

        if (res.data.code === 0 && res.data.data.tevalisFlag) {
          this.tevalisFlag = true;
        }

        if (res.data.code === 0 && res.data.data.redcatFlag) {
          this.redcatFlag = true;
        }

        if (res.data.code === 0 && res.data.data.oolioFlag) {
          this.oolioFlag = true;
        }

        if (res.data.code === 0 && res.data.data.squareFlag) {
          this.squareFlag = true;
        }

        if (res.data.code === 0 && res.data.data.swiftPosFlag) {
          this.swiftPosFlag = true;
        }
      }
    })

  },
  created() {
    this.$root.$on('isPro', (isPro, others) => {
      this.isPro = isPro
      this.isRevenueTargetForecastActivated = others.isRevenueTargetForecastActivated
    })
  }
}
</script>



<style lang="scss" scoped>
.table-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-size: 20px;
    font-weight: 600;
  }

  &__button {
    border: 2px solid #EA3796;
    padding: 8px 25px !important;
    font-size: 15px;
    color: #EA3796;
    height: auto !important;
    width: auto !important;
  }
}

.wrp {
  width: 100%;

  .top-tit {
    font-size: 24px;
    color: var(--text-color);
    line-height: 28px;
    margin-bottom: 38px;
    font-weight: 600;
  }

  .red {
    color: #EA3796;
  }

  h1 {
    font-size: 20px;
    margin-bottom: 39px;
    font-weight: 600;
    line-height: 60px;
    margin-bottom: 27px;

    span {
      float: left;
      position: relative;
      cursor: pointer;
      color: #A6A7A9;
      margin-right: 36px;
    }

    .active {
      color: var(--text-color);

      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 110%;
        height: 2px;
        background: #EA3796;
      }
    }

    button {
      float: right;
      display: block;
      outline: none;
      background: none;
      cursor: pointer;
      width: 280px;
      height: 60px;
      border: 2px solid #EA3796;
      color: #EA3796;
      margin: 0 auto;
      font-size: 26px;
    }
  }

  .table-wrp {
    margin-bottom: 30px;

    .el-table__cell {
      padding: 20px !important;
    }

    .icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      mask-repeat: no-repeat !important;
      mask-size: 24px 24px !important;
      mask-position: center center !important;
      background-color: var(--text-color);
      mask: url('../../assets/pencil-square.svg');
      -webkit-mask: url('../../assets/pencil-square.svg');
      cursor: pointer;
    }
  }

  .btns {
    margin: 65px auto 0 auto;
    width: 610px;
  }

  button {
    width: 280px;
    height: 60px;
    outline: none;
    background: none;
    cursor: pointer;
    font-weight: 600;
  }

  .dark {
    border: 2px solid var(--text-color);
    color: var(--text-color);
    font-size: 26px;
    float: left;
  }

  .light {
    border: 2px solid #8E3771;
    color: #8E3771;
    font-size: 26px;
    float: right;
  }

  .usable {
    border: 2px solid #EA3796;
    color: #EA3796;
  }

  .pop-wrp {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    background: var(--background-color-2);
    bottom: 0;
    right: 0;
    z-index: 102;

    .pop-confirm {
      width: 1250px;
      height: 280px;
      background: var(--background-color-4);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -140px 0 0 -625px;

      .triple {
        text-align: center;

        button {
          width: 280px;
          height: 60px;
          background: var(--background-color-4);
          box-sizing: border-box;
          font-size: 26px;
          font-family: PingFangSC-Semibold, PingFang SC;
        }

        button:nth-child(1),
        button:nth-child(2) {
          margin-right: 50px;
        }

        button:nth-child(1) {
          color: var(--text-color);
          border: 2px solid var(--text-color);
        }

        button:nth-child(3),
        button:nth-child(2) {
          color: #D13A90;
          border: 2px solid #D13A90;
        }
      }
    }

    h1 {
      font-size: 24px;
      line-height: 33px;
      font-weight: 600;
      margin-bottom: 50px;
      color: var(--text-color);
      text-align: center;
    }

    .btns {
      margin: 65px auto 0 auto;
      width: 610px;

      button {
        width: 280px;
        height: 60px;
        outline: none;
        background: none;
        cursor: pointer;
        font-weight: 600;
      }

      .dark {
        border: 2px solid var(--text-color);
        color: var(--text-color);
        font-size: 26px;
        float: left;
      }

      .light {
        border: 2px solid #8E3771;
        color: #8E3771;
        font-size: 26px;
        float: right;
      }

      .usable {
        border: 2px solid #EA3796;
        color: #EA3796;
      }
    }

    .normal {
      transform: rotate(0deg);
      opacity: 1;
      margin-left: -420px;
    }

    .second-step {
      width: 840px;
      height: 612px;
      background: var(--background-color);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -306px 0 0 -420px;
      box-sizing: border-box;
      padding: 65px 50px 0 50px;

      h2 {
        margin-bottom: 30px;
      }

      .upload-con {
        width: 100%;
        height: 280px;
        background: var(--background-color-2);
        box-sizing: border-box;
        border: 1px solid #5F5F5F;
        position: relative;
        text-align: center;

        .close {
          width: 20px;
          position: absolute;
          height: 20px;
          right: 28px;
          top: 69px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
          background-image: url('../../assets/c.png');
          cursor: pointer;
        }

        .icon {
          display: block;
          width: 100%;
          height: 35px;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center center;
          background-image: url('../../assets/upload.png');
          margin-top: 80px;
          margin-bottom: 30px;
        }

        h3 {
          font-size: 20px;
          line-height: 28px;
          text-align: center;
          color: var(--text-color);

          span {
            color: #D13A90;
          }
        }

        .upload-demo {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          bottom: 0;
        }

        .el-icon-loading {
          margin-top: 100px;
          font-size: 30px;
        }

        .file {
          width: 660px;
          height: 120px;
          background: var(--background-color-4);
          position: relative;
          margin: 80px auto 0 auto;
          display: flex;
          flex-direction: row;
          box-sizing: border-box;
          padding: 20px;

          .in {
            width: 80px;
            height: 80px;
            margin-right: 20px;
            background-size: contain;
            background-image: url('../../assets/a.png');
            background-position: center center;
            background-repeat: no-repeat;
            flex: 0 0 auto;
          }

          .text {
            flex: 0 0 auto;
            text-align: left;
            width: 520px;

            .tit {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              font-size: 24px;
              line-height: 33px;
              margin-bottom: 10px;
              margin-top: 5px;
            }

            .size {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              font-size: 20px;
              line-height: 28px;
            }
          }
        }
      }
    }

    .upload-success {
      width: 410px;
      height: 349px;
      background: var(--background-color);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -176px 0 0 -210px;
      box-sizing: border-box;
      padding: 60px 50px 0 50px;

      i {
        display: block;
        width: 100%;
        height: 60px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        margin-bottom: 40px;
        background-image: url('../../assets/s.png');
      }

      h4 {
        font-size: 24px;
        line-height: 29px;
        margin-bottom: 50px;
        color: var(--text-color);
        text-align: center;
      }

      button {
        width: 100%;
      }
    }

    .lst {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      input {
        width: 100%;
        margin: 0;
        padding: 0;
        background: none;
        outline: none;
        border: none;
        font-size: 16px;
        color: var(--text-color);
        box-sizing: border-box;
        padding: 0 10px;
        text-align: center;
      }

      .box {
        width: 1250px;
        background: var(--background-color);
        box-sizing: border-box;
        padding: 65px 50px 65px 50px;

        .table-wrp {
          margin-bottom: 15px;
        }

        p {
          font-size: 18px;
          line-height: 25px;
          color: var(--text-color);
        }
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/revenue/accountingTable.vue